import React from "react";
import { Link } from "react-router-dom";

/*eslint-disable */

declare const window: any;

interface MenuPosventaComponentProps {
  selectedMenu: any;
  navigate: any;
  setSelectedMenu: any;
  visibleHeight: any;
  menus: any;
}

const MenuPosventaComponent: React.FC<MenuPosventaComponentProps> = ({
  selectedMenu,
  navigate,
  setSelectedMenu,
  visibleHeight,
  menus,
}) => {
  const handlesendMenuDataLayer = (main: any, category: any) => {
    const dataLayerEvent: any = {
      event: "menu_click",
      comp_page: {
        position: "top menu",
        main_category: main,
        selected_category: category,
      },
    };

    // Empujar al dataLayer
    if (window.dataLayer) {
      window.dataLayer.push(dataLayerEvent);
    }
  };

  return (
    <div
      className="menu-posventa-detail-component"
      style={visibleHeight <= 0 ? { top: `0px` } : {}}
    >
      <div className="content-menu-posventa-detail-component">
        {menus?.servicios_exclusivos ? (
          <Link
            to="/posventa/servicios-exclusivos"
            className={`individual-content-menu-posventa-detail-component ${
              selectedMenu === "servicios-exclusivos" ? "active" : ""
            }`}
            onClick={() => {
              navigate("#diseno"), setSelectedMenu("servicios-exclusivos"), handlesendMenuDataLayer("Posventa", "Servicios exclusivos");
            }}
          >
            Servicios exclusivos
          </Link>
        ) : null}
        {menus?.garantia ? (
          <Link
            to="/posventa/garantia"
            className={`individual-content-menu-posventa-detail-component ${
              selectedMenu === "garantia" ? "active" : ""
            }`}
            onClick={() => {
              navigate("#versiones"), setSelectedMenu("garantia"), handlesendMenuDataLayer("Posventa", "Garantía");
            }}
          >
            Garantía
          </Link>
        ) : null}
        {menus?.campanias ? (
          <Link
            to="/posventa/campana"
            className={`individual-content-menu-posventa-detail-component ${
              selectedMenu === "campana" ? "active" : ""
            }`}
            onClick={() => {
              navigate("#campania"), setSelectedMenu("campana"), handlesendMenuDataLayer("Posventa", "Campaña de seguridad");
            }}
          >
            Campaña de seguridad
          </Link>
        ) : null}
        {menus?.asistencia ? (
          <Link
            to="/posventa/asistencia"
            className={`individual-content-menu-posventa-detail-component ${
              selectedMenu === "asistencia" ? "active" : ""
            }`}
            onClick={() => {
              navigate("#asistencia"), setSelectedMenu("asistencia"), handlesendMenuDataLayer("Posventa", "Asistencia");
            }}
          >
            Asistencia
          </Link>
        ) : null}
        {menus?.mantenimiento ? (
          <Link
            to="/posventa/mantenimiento"
            className={`individual-content-menu-posventa-detail-component ${
              selectedMenu === "mantenimiento" ? "active" : ""
            }`}
            onClick={() => {
              navigate("#mantenimiento"), setSelectedMenu("mantenimiento"), handlesendMenuDataLayer("Posventa", "Mantenimiento");
            }}
          >
            Mantenimiento
          </Link>
        ) : null}
        {menus?.repuestos_genuinos ? (
          <Link
            to="/posventa/repuestos-genuinos"
            className={`individual-content-menu-posventa-detail-component ${
              selectedMenu === "repuestos-genuinos" ? "active" : ""
            }`}
            onClick={() => {
              navigate("#repuestos"), setSelectedMenu("repuestos-genuinos"), handlesendMenuDataLayer("Posventa", "Repuestos genuinos");
            }}
          >
            Repuestos genuinos
          </Link>
        ) : null}
        <Link
          to={`/cita-taller`}
          className="cotiza-opciones-menu-posventa-detail-component"
          onClick={() => handlesendMenuDataLayer("Posventa", "Agenda Cita Taller")}
        >
          Agenda Cita Taller
        </Link>
      </div>
    </div>
  );
};

export default MenuPosventaComponent;
